// extracted by mini-css-extract-plugin
module.exports = {"topRow":"S5uX73aIPynM7CxeXUREL","logo":"_3PHTEp3u0PJ37oS1NF3MRQ","socials":"_2zc1fnIxdyWoO8H7QxTrgu","links":"_1jshV9B6Ws_F8eDyQ8HJe_","link":"_2KcKJd8-Ph6ohJx0mGFqOJ"};